<template>
  <div class="animated fadeIn">
    <statistic-tile :text="text" :fa-icon="faIcon" :variant="variant">
      <template #stat_value>
        <span v-if="loading"><i class="fa fa-spin fa-spinner"></i></span>
        <span v-if="!loading">
          <slot v-bind:value="value">
            {{ value || "N/A" }}
          </slot>
        </span>
      </template>
    </statistic-tile>
  </div>
</template>

<script>
import LabIndicatorModel from "@/models/lab/IndicatorModel";
import CashierIndicatorModel from "@/models/cashier/IndicatorModel";
import CrmIndicatorModel from "@/models/crm/IndicatorModel";
import StatisticTile from "./StatisticTile";

export default {
  name: "IndicatorTile",
  components: { StatisticTile },
  props: {
    indicator_key: {
      type: String,
      default: null,
    },
    indicator_service: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    faIcon: {
      type: String,
      default: null,
    },
    variant: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      indicator: null,
      value: null,
      loading: true,
    };
  },
  methods: {
    async init() {
      let indicator = null;

      switch (this.indicator_service) {
        case "cashier":
          indicator = new CashierIndicatorModel();
          break;
        case "crm":
          indicator = new CrmIndicatorModel();
          break;
        case "lab":
        default:
          indicator = new LabIndicatorModel();
      }
      try {
        await indicator.latest(this.indicator_key);

        this.indicator = indicator;
        this.value = indicator.value;
        this.loading = false;
      } catch ({ response }) {
        console.log(`response`, response);
      }
    },
  },
  created() {
    this.loading = true;

    this.init();
  },
};
</script>
